<template>
  <b-col cols="12" class="add-origin-destination">
    <button
      :class="`add-origin-destination__button ${
        disabled ? 'add-origin-destination__button--disabled' : ''
      }`"
      type="button"
      role="button"
      @click="() => $emit('add:origin-destination')"
      :disabled="disabled"
    >
      <span>Aggiungi un altro volo</span>
      <vb-icon name="plus_circle" :size="16" />
    </button>
  </b-col>
</template>

<script>
export default {
  name: "add-origin-destination",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.add-origin-destination {
  display: flex;
  justify-content: flex-end;

  @include media-breakpoint-down(lg) {
    justify-content: center;
  }

  &__button {
    color: var(--info);
    ::v-deep svg {
      --color: var(--info);
    }
    border: none;
    background-color: transparent;
    font-size: $font-size-base;
    font-weight: $vb-font-weight-semibold;
    display: flex;
    align-items: center;
    gap: 5px;

    &--disabled {
      color: #ADB5BD;
      ::v-deep svg {
        --color: #ADB5BD;
      }
    }
  }
}
</style>
